module.exports = "<div class=\"disclaimer\">\r\n    <strong>Disclaimer: </strong>{{osrDisclaimerText | async}}\r\n</div>"